module.exports = __webpack_public_path__ + "static/img/newnew-reg.a5c3bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newnew-reg.png
// module id = 366
// module chunks = 32